import { createReducer, on } from '@ngrx/store';

import { DataState } from '../../interfaces';
import { DataActions } from '../actions';

export const initialState: DataState = {
  availability: null,
  flights: null,
  weeklyFlights: null,
};

const statusReducer = createReducer(
  initialState,
  on(DataActions.setResults, (state, data) => ({
    ...state,
    availability: data.availability,
    weeklyFlights: data.weeklyFlights,
    flights: {
      ...state.flights,
      ...data.flights,
    },
  })),
  on(DataActions.clearResults, () => ({
    ...initialState,
  }))
);

export function reducer(state: DataState, action: DataActions.StateActionsUnion): DataState {
  return statusReducer(state, action);
}
